<template>
    <div>
        <base-header type="gradient-primary" class="pb-6 pb-8 pt-5 pt-md-8">
            <div v-if="selectedProfile == 'developer_accounts'" class="row">
                <div class="col-xl-3 col-lg-6">
                    <stats-card title="For Approval"
                                type="gradient-red"
                                :sub-title="forApprovalAccountCount"
                                icon="fa fa-user-slash"
                                class="mb-4 mb-xl-0">
                        <template slot="footer">
                            <span class="mr-2"> pending user {{ forApprovalAccountCount > 1 ? _.pluralize('account') : 'account'}}</span>
                            <br><br>
                        </template>
                    </stats-card>
                </div>
                <div class="col-xl-3 col-lg-6">
                    <stats-card title="Active Accounts"
                                type="gradient-green"
                                :sub-title="activeAccountCount"
                                icon="fa fa-user"
                                class="mb-4 mb-xl-0">
                        <template slot="footer">
                            <span class="mr-2"> active user {{ activeAccountCount > 1 ? _.pluralize('account') : 'account'}}</span>  
                            <br><br>
                        </template>
                    </stats-card>
                </div>
            </div>

            <div v-if="selectedProfile == 'wavelet_manager'" class="row">
                <div class="col-xl-3 col-lg-6">
                    <stats-card title="For Approval"
                                type="gradient-red"
                                :sub-title="forApprovalWaveletsCount"
                                icon="fa fa-check-double"
                                class="mb-4 mb-xl-0">
                        <template slot="footer">
                            <span class="mr-2"> pending {{ forApprovalWaveletsCount > 1 ? _.pluralize('wavelet') : 'wavelet'}}</span>
                            <br><br>
                        </template>
                    </stats-card>
                </div>
               <div class="col-xl-3 col-lg-6">
                    <stats-card title="Live"
                                type="gradient-green"
                                :sub-title="liveWaveletsCount"
                                icon="fa fa-play-circle"
                                class="mb-4 mb-xl-0">
                        <template slot="footer">
                            <span class="mr-2"> active {{ liveWaveletsCount > 1 ? _.pluralize('wavelet') : 'wavelet'}}</span>
                            <br><br>
                        </template>
                    </stats-card>
                </div>
                <div class="col-xl-3 col-lg-6">
                    <stats-card title="On development"
                                type="gradient-orange"
                                :sub-title="onDevelopmentWaveletsCount"
                                icon="fa fa-tools"
                                class="mb-4 mb-xl-0">
                        <template slot="footer">
                            <span class="mr-2"> ongoing development {{ onDevelopmentWaveletsCount > 1 ? _.pluralize('wavelet') : 'wavelet'}}</span>
                            <br><br>
                        </template>
                    </stats-card>
                </div>
            </div>

            <br><br>
            <base-dropdown >
                <base-button slot="title" type="success" class="dropdown-toggle">
                    Developer - {{ _.startCase(selectedProfile)}}
                </base-button>
                    <a @click.prevent="setCurrentProfile('developer_accounts')" class="dropdown-item" href="#">Developer Accounts</a>
                    <a @click.prevent="setCurrentProfile('wavelet_manager')" class="dropdown-item" href="#">Wavelet Manager</a>
            </base-dropdown>
        </base-header>
        <div v-if="selectedProfile == 'developer_accounts'" class="container-fluid mt--7">
            <developer-account />
        </div>        
        <div v-else-if="selectedProfile == 'wavelet_manager'" class="container-fluid mt--7">
            <wavelet-manager />
        </div>   
    </div>
</template>

<script>
import HTTPRequest from '../../controllers/httpRequest.js'
import DeveloperAccount from '../Developer/DeveloperAccount.vue'
import WaveletManager from '../Wavelet/WaveletManager.vue'
import { mapState } from 'vuex'

export default {
  components: {
    DeveloperAccount,
    WaveletManager
  },
  mounted: async function(){  
    
  },
  computed: {
      ...mapState(['endPoint']),
  },
  data () {
    return {
        selectedProfile: "developer_accounts",
        activeAccountCount: '0',
        forApprovalAccountCount: '0',
        forApprovalWaveletsCount: '0',
        liveWaveletsCount: '0',
        onDevelopmentWaveletsCount: '0',
    }
  },
  mounted: function(){
        this.retrieveStatistics()
  },
  methods: {
    setCurrentProfile(profile){
        this.selectedProfile = profile
    },
    async retrieveStatistics(){
        var developer_account_stats = await HTTPRequest.getRequest(this.endPoint + 'developer_accounts/statistics', null)
        if (developer_account_stats) this.activeAccountCount = developer_account_stats['active_accounts'].toString()
        if (developer_account_stats) this.forApprovalAccountCount = developer_account_stats['for_approval_accounts'].toString()
    
        var wavelet_stats = await HTTPRequest.getRequest(this.endPoint + 'wavelets/statistics', null)
        if (wavelet_stats) this.forApprovalWaveletsCount = wavelet_stats['for_approval_wavelets'].toString()
        if (wavelet_stats) this.liveWaveletsCount = wavelet_stats['live_wavelets'].toString()
        if (wavelet_stats) this.onDevelopmentWaveletsCount = wavelet_stats['on_development_wavelets'].toString()
    },
  },
}
</script>

<style>
</style>


